import React, { Component } from "react";
import { connect } from "react-redux";

import {
    closeConfigModal,
    toggle_configLocalBroadcastLive,
    toggle_editBroadcastLive,
    toggle_editBroadcastLiveMember,
    toggle_removeBroadcastLive,
    toggle_removeBroadcastLiveMember,
    updateLiveName,
    removeLive,
    removeLiveMember,
    updateLiveMember,
    updatePublicYnForLocalLive,
    requestUpdateMixedClassExistYn,
    toggle_powerOffLive,
    powerOffLive,
    // updateMixedClassSeq,
} from "../../modules/live";

import { get_class_monitor_use, update_class_monitor_use } from "../../lib/api/user";

import ConfigLiveListTitleTemplate from "../../components/template/title/ConfigLiveListTitleTemplate";

import ToppedModal from "../../components/template/modal/ToppedModal";
import CenteredModal from "../../components/template/modal/CenteredModal";
import RightSideModal from "../../components/template/modal/RightSideModal";

import ConfigMyBroadcastLiveList from "../../components/live/ConfigMyBroadcastLiveList";
import ConfigBroadcastLiveMember from "../../components/live/modal/ConfigBroadcastLiveMember";
import ConfigLocalLive from "../../components/live/modal/ConfigLocalLive";
import EditLive from "../../components/live/modal/EditLive";
import RemoveLive from "../../components/live/modal/RemoveLive";
import RemoveLiveMember from "../../components/live/modal/RemoveLiveMember";
import LiveMemberLimit from "../../components/live/modal/LiveMemberLimit";
import PowerOffLive from "../../components/live/modal/PowerOffLive";

class ConfigMyBroadcastLiveListContainer extends Component {

    // 20260826 로컬 클래스 설정 모달에서 클래스 모니터 API를 호출할 수 있도록 중계한다.
    getClassMonitorUse = (liveSeq) => {
        return get_class_monitor_use(liveSeq, this.props.userSeq).then(response => response.data);
    }

    // 20260826 로컬 클래스 설정 모달에서 클래스 모니터 사용 여부 저장 API를 호출할 수 있도록 중계한다.
    updateClassMonitorUse = (liveSeq, classMonitorUseYN) => {
        return update_class_monitor_use(liveSeq, this.props.userSeq, classMonitorUseYN).then(response => response.data);
    }

    handleSelectedConfigFunc = ({ selectedFunc, liveSeq, liveName, memberSeq, memberInfo, status, message, publicYn, mixedClassSeq, data }) => {
        const { userSeq, serverUserSeq, localServerSeq } = this.props;

        switch (selectedFunc) {
            case "EDIT_LOCAL_LIVE":
                console.log("edit local live");
                this.props.toggle_configLocalBroadcastLive({ selectedFunc, liveSeq });
                break;

            case "UPDATE_MIXED_EXIST_YN":
                this.props.requestUpdateMixedClassExistYn({ selectedFunc, liveSeq, liveName, userSeq, mode: "hiclass", data: { status, serverUserSeq, localServerSeq } });
                break;

            case "EDIT_TOGGLE":
                console.log("edit toggle");
                this.props.toggle_editBroadcastLive({ selectedFunc, liveSeq });
                break;

            case "UPDATE_LIVE_INFO":
                this.props.updateLiveName({ selectedFunc, liveSeq, liveName, userSeq, mode: "hiclass" });
                break;

            case "UPDATE_MIXED_LIVE_INFO":
                // this.props.updateLiveName({ selectedFunc, liveSeq, liveName, userSeq, mode: "hiclass", data: { status, serverUserSeq } });
                this.props.updateLiveName({ selectedFunc, liveSeq, liveName, userSeq, mode: "hiclass" });
                break;

            case "REMOVE_TOGGLE":
                this.props.toggle_removeBroadcastLive({ selectedFunc, liveSeq });
                break;

            case "REMOVE":
                this.props.removeLive({ selectedFunc, liveSeq, userSeq, mode: "hiclass" });
                break;

            case "EDIT_MEMBER_TOGGLE":
                this.props.toggle_editBroadcastLiveMember({ selectedFunc, liveSeq });
                break;

            case "MEMBER_ACCEPT":
                this.props.updateLiveMember({ liveSeq, userSeq: memberSeq, liveCertiYN: "Y", mode: "hiclass" });
                break;

            case "MEMBER_REJECT":
                this.props.updateLiveMember({ liveSeq, userSeq: memberSeq, liveCertiYN: "R", mode: "hiclass" });
                break;

            case "MEMBER_REMOVE_TOGGLE":
                this.props.toggle_removeBroadcastLiveMember({ selectedFunc, memberInfo })
                break;

            case "MEMBER_REMOVE":
                this.props.removeLiveMember({ liveSeq, userSeq: memberSeq, mode: "hiclass" });
                break;

            case "NONE":
                // this.props.handleSelectedFunc({ selectedFunc: "MESSAGE", message: "" });
                this.props.closeConfigModal({ selectedFunc });
                break;

            case "MESSAGE":
                this.props.handleSelectedFunc({ selectedFunc, message });
                break;

            case "UPDATE_PULIC_YN":
                this.props.updatePublicYnForLocalLive({ liveSeq, userSeq: this.props.userSeq, publicYn });
                break;

            case "POWER_OFF_TOGGLE":
                this.props.toggle_powerOffLive({ liveSeq });
                break;

            case "POWER_OFF":
                this.props.powerOffLive({ userNickname: this.props.userNickname });
                break;

            /* case "UPDATE_MIXED_CLASS_SEQ":
                console.log(" liveSeq - ", liveSeq);
                console.log(" mixedClassSeq - ", mixedClassSeq);
                this.props.updateMixedClassSeq({ localLiveSeq: liveSeq, mixedClassSeq: mixedClassSeq });
                break; */

            default:
                break;
        }
    }

    render() {
        const { userSeq, serverUserSeq, list_live, selectedLiveInfo, selectedLiveMemberInfo, closedLive_Info } = this.props;
        const { handleSelectedFunc, alertKind, alertMessage } = this.props;
        const { handleSelectedConfigFunc } = this;

        return (
            <>
                {
                    this.props.isConfigLocalLiveModalOpened &&
                    <ToppedModal modalClose={handleSelectedConfigFunc}>
                        <ConfigLocalLive
                            selectedLiveInfo_liveSeq={selectedLiveInfo.liveSeq}
                            selectedLiveInfo_mixedClassExistYn={selectedLiveInfo.mixedClassExistYn}
                            selectedLiveInfo_mixedClassSeq={selectedLiveInfo.mixedClassSeq}
                            selectedLiveInfo={selectedLiveInfo}
                            serverUserSeq={serverUserSeq}
                            alertKind={alertKind}
                            alertMessage={alertMessage}
                            handleSelectedConfigFunc={handleSelectedConfigFunc}
                            getClassMonitorUse={this.getClassMonitorUse}
                            updateClassMonitorUse={this.updateClassMonitorUse}
                        />
                    </ToppedModal>
                }
                {
                    this.props.isEditLiveModalOpened &&
                    <ToppedModal modalClose={handleSelectedConfigFunc}>
                        <EditLive
                            selectedLiveInfo={selectedLiveInfo}
                            serverUserSeq={serverUserSeq}
                            alertKind={alertKind}
                            alertMessage={alertMessage}
                            handleSelectedConfigFunc={handleSelectedConfigFunc}
                        />
                    </ToppedModal>
                }
                {
                    this.props.isEditLiveMemberModalOpened &&
                    <RightSideModal modalClose={handleSelectedConfigFunc}>
                        <ConfigBroadcastLiveMember
                            selectedLiveInfo={selectedLiveInfo}
                            handleSelectedConfigFunc={handleSelectedConfigFunc}
                        />
                    </RightSideModal>
                }
                {
                    this.props.isRemoveLiveModalOpened &&
                    <CenteredModal modalClose={handleSelectedConfigFunc}>
                        <RemoveLive
                            selectedLiveInfo={selectedLiveInfo}
                            handleSelectedConfigFunc={handleSelectedConfigFunc}
                        />
                    </CenteredModal>
                }
                {
                    this.props.isRemoveLiveMemberModalOpened &&
                    <CenteredModal modalClose={handleSelectedConfigFunc}>
                        <RemoveLiveMember
                            selectedLiveMemberInfo={selectedLiveMemberInfo}
                            handleSelectedConfigFunc={handleSelectedConfigFunc}
                        />
                    </CenteredModal>
                }
                {
                    this.props.isLiveMemberLimitModalOpened &&
                    <CenteredModal modalClose={handleSelectedConfigFunc}>
                        <LiveMemberLimit
                            live_info={closedLive_Info}
                            handleSelectedConfigFunc={handleSelectedConfigFunc}
                        />
                    </CenteredModal>
                } {
                    this.props.isPowerOffModalOpened &&
                    <CenteredModal modalClose={handleSelectedConfigFunc}>
                        <PowerOffLive
                            selectedLiveInfo={selectedLiveInfo}
                            handleSelectedFunc={handleSelectedConfigFunc}
                        />
                    </CenteredModal>
                }
                <ConfigLiveListTitleTemplate
                    handleSelectedFunc={handleSelectedFunc}
                />
                <ConfigMyBroadcastLiveList
                    userSeq={userSeq}
                    list_live={list_live}
                    handleSelectedConfigFunc={handleSelectedConfigFunc}
                />
            </>
        )
    }
}

export default connect(
    ({ user, live }) => ({
        userSeq                         : user.userSeq,
        serverUserSeq                   : user.serverUserSeq,
        localServerSeq                  : user.localServerSeq,
        userNickname                    : user.userNickname,

        list_live                       : live.list_live,

        selectedLiveInfo                : live.selectedLiveInfo,
        selectedLiveMemberInfo          : live.selectedLiveMemberInfo,

        list_defaultWhitelist           : live.list_defaultWhitelist,

        isEditLiveModalOpened           : live.isEditLiveModalOpened,
        isEditLiveMemberModalOpened     : live.isEditLiveMemberModalOpened,
        isConfigLocalLiveModalOpened    : live.isConfigLocalLiveModalOpened,
        isRemoveLiveModalOpened         : live.isRemoveLiveModalOpened,
        isRemoveLiveMemberModalOpened   : live.isRemoveLiveMemberModalOpened,
        isLiveMemberLimitModalOpened    : live.isLiveAlertModalMemberLimitOpened,
        isPowerOffModalOpened           : live.isPowerOffModalOpened,

        closedLive_Info                 : live.closedPerformLiveInfo
    }),
    {
        closeConfigModal,

        toggle_configLocalBroadcastLive,
        toggle_editBroadcastLive,
        toggle_editBroadcastLiveMember,
        toggle_removeBroadcastLive,
        toggle_removeBroadcastLiveMember,

        updateLiveName,
        removeLive,
        updateLiveMember, 
        removeLiveMember,
        updatePublicYnForLocalLive,
        requestUpdateMixedClassExistYn,
        powerOffLive,
        toggle_powerOffLive,
        // updateMixedClassSeq,
    }
)(ConfigMyBroadcastLiveListContainer);